// extracted by mini-css-extract-plugin
export var optionGrid = "_3x-7";
export var optionList = "_3x-6";
export var questionsBlock = "_3x-9";
export var spacer = "_3x-5";
export var stepCenteredContent = "_3x-3";
export var stepInner = "_3x-0";
export var stepInnerFullWidth = "_3x-1";
export var stepInnerLockScroll = "_3x-2";
export var stepTransitionFrame = "_3x-4";
export var welcomeBlock = "_3x-8";